// extracted by mini-css-extract-plugin
module.exports = {"wrapperMain":"UserList_wrapperMain__igwJm","wrapperInner":"UserList_wrapperInner__1lbcq","wrapperDivider":"UserList_wrapperDivider__3dAkD","p":"UserList_p__caVg4"};